import React, { useEffect, useState, useRef } from 'react';
import { Divider, Button, message } from 'antd';
import CVScore from '../CVScore';
import Comment from './Comment';
import FeedbackEvaluation from './FeedbackEvaluation';
import AddComment from './AddComment';
import { useDispatch, useSelector } from 'react-redux';
import { selectCandidateProfile, setCandidateProfile, selectMentions, setMentions, setInputCommentValue, setIsEditingComment, selectIsEditingComment, selectSelectedCommentId, setSelectedCommentId } from '../../../slice/candidateSlice';
import { EmptyList } from '../../../../../shared/components/List/EmptyList';
import { IMentionMember, permissionsActions } from '../../../../../shared/utils/interfaces/AuthInterface';
import { useDeleteCommentMutation, useGetFeedbackQuery, useGetMembersQuery } from '../../../slice/candiddateApiSlice';
import { FeedbackTypeId, IGetFeedback } from '../../../../../shared/utils/interfaces/commentsFaces';
import { useNavigate, useParams } from 'react-router-dom';
import { IMemberItem } from '../../../../../shared/utils/interfaces/createJobTabs';
import { regexPatterns } from '../../../../../shared/utils/regexPatterns';
import ModalComponent from '../../../../../shared/components/Modals/ModalComponent';
import ModalBody from '../../../../../shared/components/Modals/ModalBody';
import ChangeStageActions from '../ChangeStageActions';
import Attributes from '../Attributes';
import { errorMessage, roleError } from '../../../../../shared/utils/constantData';
import { WithTooltip } from '../../../../../shared/components/tooltip.tsx/withTootip';
import FeaturesList from './FeaturesList';
import DeleteModal from '../../../../../shared/components/Modals/DeleteModal';
import CandidatesActions from '../CandidatesActions';
import officeIcon from '../../../../../shared/assets/images/Office building.svg'
import { usePermissions } from '../../../../../shared/utils/customHooks/usePermissions';
import ExclamationYellow from '../../../../../shared/assets/images/ExclamationYellow.svg';
import { EvaluationForm } from './CommunicationQuestions';
import AiEvaluationSummary from './AiEvaluationSummary';
import { useLazyGetEvaluationByIdQuery, useLazyGetEvaluationKitByCandidateIdQuery } from '../../../../interview/slice/interviewApiSlice';
import { selectEvaluationId, selectEvaluationView, setEvaluationId, setGenerateEvaluationKitModal, setEvaluationSections, setEvaluationView, setIsLoadingEvaluationData, setShowPreview, selectEvaluationSections, setSelectedKit, setIsStartingWithEvaluationKit, setIsSuccessSavingEvaluationKitTosStage, setSelectedKitTemplateData, selectIsStartingWithEvaluationKit, setSelectedTemplate, setIsEvaluationQuestionsModal } from '../../../../interview/slice/interviewSlice';
import { IMetrics, ISection } from '../../../../../shared/utils/interfaces/interviewKit';
import { GlobalStageTypesId } from '../../../../../shared/utils/interfaces/candidatesListFace';
import { useDeleteEvaluationMutation } from '../../../../interview/slice/interviewApiSlice';
import { setDeleteEvaluationModal, selectDeleteEvaluationModal } from "../../../../interview/slice/interviewSlice"
import { apiStatuses } from '../../../../../shared/utils/constantData';
import { PreviewQuestions } from '../../../../interview/components/kit/PreviewQuestions';
import { truncate } from '../../../../../shared/utils/functions/typography';
import { selectCurrentUser } from '../../../../authentication/slice/authSlice';
import GenerateKitModal from './Evaluation/GenerateKitModal';
import { EvaluationQuestionsModal } from './Evaluation/EvaluationQuestionsModal';
import { InterviewKitNameModal } from '../../../../interview/components/kit/InterviewKitNameModal';
import LazyLoader from '../../../../../shared/components/LazyLoader/load';
import RejectionAction from '../RejectionAction';
import { CandidateInfo } from './CandidateInfo';

const formatCommentMentions = (text: string, mentionables: IMentionMember[]) => {
    const lines = text.split('\n');
    while (lines.length > 0 && lines[lines.length - 1].trim() === '') {
        lines.pop();
    }

    return (
        <>
            {lines.map((line, lineIdx) => (
                <React.Fragment key={lineIdx}>
                    {line.split(' ').map((word, key) => {
                        const memberName = mentionables.find(({ id }) => Number(word.replace(/^.*\((\d+)\).*$/, '$1')) === id)?.display
                        return (
                            regexPatterns.mentionPattern.test(word) && mentionables.some(({ id }) => Number(word.replace(/^.*\((\d+)\).*$/, '$1')) === id) ?
                                <span key={key} className='text-indigo-700'>{'@' + memberName} </span>
                                : regexPatterns.mentionPattern.test(word) ?
                                    word.replace(regexPatterns.mentionWithAtSymbol, '') + ' '
                                    :
                                    word + ' '
                        )
                    })}
                    {lineIdx < lines.length - 1 && <br />}
                </React.Fragment>))
            }
        </>
    )
}

const Comments: React.FC = () => {
    const dispatch = useDispatch();
    const candidate = useSelector(selectCandidateProfile);
    const evaluationView = useSelector(selectEvaluationView)
    const evaluationSections = useSelector(selectEvaluationSections)
    const user = useSelector(selectCurrentUser);
    const isEditingComment = useSelector(selectIsEditingComment);
    const selectedCommentId = useSelector(selectSelectedCommentId);
    const navigate = useNavigate();
    const { applicationId, jobId } = useParams();
    const [kitTitle, setKitTitle] = useState<string>('');
    const {
        data: feedbackData,
        isSuccess: isSuccessFeedback,
        isFetching: isFetchingFeedback,
        isLoading: isLoadingFeedback,
        isError: isErrorFeedback
    } = useGetFeedbackQuery(applicationId);
    const {
        data: membersData,
        isSuccess: isSuccessMembers,
    } = useGetMembersQuery(jobId);
    const [triggerGetEvaluationKit, { isLoading, isFetching }] = useLazyGetEvaluationKitByCandidateIdQuery();
    const mentionables = useSelector(selectMentions);
    const [viewMore, setViewMore] = useState<boolean>(true);
    const [openWarningModal, setOpenWarningModal] = useState(false)
    const [isOpenDeleteCommentModal, setIsOpenDeleteCommentModal] = useState(false)
    const [feedbacks, setFeedbacks] = useState<IGetFeedback[]>([])
    const { getInterviewQuestions } = permissionsActions
    const { hasJobPermission } = usePermissions()
    const departmentName = candidate?.department?.name
    const parentDepartment = candidate?.department?.parentDepartment?.name
    const [feedbackEvaluationId, setFeedbackEvaluationID] = useState<Number>()
    const [deleteEvaluation, { isLoading: isLoadingDelete, isSuccess, isError, error }] = useDeleteEvaluationMutation();
    const [getEvaluationById, { isFetching: isLoadingEvaluationData, isSuccess: isSuccessEvaluation, isError: isErrorEvaluation, data: evaluationData }] = useLazyGetEvaluationByIdQuery();
    const [deleteComment, { isLoading: isLoadingDeleteComment, isSuccess: isSuccessDeleteComment, isError: isErrorDeleteComment, error: errorDeleteComment }] = useDeleteCommentMutation();
    const deleteModalOpen = useSelector(selectDeleteEvaluationModal)
    const evaluationId = useSelector(selectEvaluationId)
    const isStartingWithEvaluationKit = useSelector(selectIsStartingWithEvaluationKit)
    const commentsContainerRef = useRef<HTMLDivElement>(null);
    const previousFeedbacksLengthRef = useRef<number>(0);

    useEffect(() => {
        if (isSuccessMembers) {
            dispatch(setMentions(membersData?.users?.length !== 0 && Array.isArray(membersData?.users) ?
                membersData?.users?.map(({ id, firstName, lastName, email }: IMemberItem) => {
                    return {
                        id,
                        display: `${firstName}${lastName}`,
                        name: `${firstName} ${lastName}`,
                        email
                    }
                }) : []))
        }
    }, [isSuccessMembers, dispatch, membersData]);

    const handleTooltipClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(`/similarApplication/${candidate?.id}`);
    };
    const getEvaluationKitData = async () => {
        try {
            const response = await triggerGetEvaluationKit(applicationId);
            const { isSuccess, data, isError } = response;
            if (isSuccess) {
                dispatch(setEvaluationView(true))
                setKitTitle(data?.kit?.title)
                mappingEvaluationData(data?.kit)
                return
            } else if (isError) {
                message.error(errorMessage)
            }

        } catch (error) {
            console.error(error);
            message.error(errorMessage)
        }
    }
    const getEvaluationPreview = async (evaluationId: number) => {
        dispatch(setEvaluationId(evaluationId))
        const response = await getEvaluationById(evaluationId)
        if (response?.data?.statusCode === apiStatuses?.success) {
            dispatch(setShowPreview(true))
        }
    }
    const handleEvaluationQuestions = () => {
        if (candidate?.hasKit) {
            getEvaluationKitData()
            dispatch(setIsStartingWithEvaluationKit(true))
        } else {
            dispatch(setIsStartingWithEvaluationKit(false))
            dispatch(setIsSuccessSavingEvaluationKitTosStage(false))
            dispatch(setGenerateEvaluationKitModal(true))
        }
    }

    const mappingEvaluationData = (data: any) => {
        let evaluationMetrics = data?.sections?.evaluationMetrics ? data?.sections?.evaluationMetrics : [];
        let aiDefaultQuestions = data?.sections?.aiDefaultQuestions;
        let generalEvaluation = data?.sections?.generalEvaluation;
        const combinedData = evaluationMetrics?.map((section: ISection) => ({
            ...section,
            metrics: section?.metrics?.map((metricData: IMetrics) => ({
                ...metricData,
                metric: metricData?.metric ? metricData?.metric : '',
                isOpen: false
            }))
        }));
        if (aiDefaultQuestions && aiDefaultQuestions?.metrics) {
            combinedData?.push({
                title: aiDefaultQuestions?.title,
                metrics: aiDefaultQuestions?.metrics?.map((metricData: IMetrics) => ({
                    metric: metricData?.metric ? metricData?.metric : '',
                    question: metricData?.question,
                    note: metricData?.note,
                    rating: metricData?.rating,
                    isOpen: false,
                }))
            });
        }

        if (generalEvaluation) {
            combinedData?.unshift({
                title: generalEvaluation?.title,
                metrics: [{
                    note: generalEvaluation?.note,
                    rating: generalEvaluation?.rating,
                    isOpen: false,
                    metric: '',
                    question: ''
                }]
            });
        }

        dispatch(setEvaluationSections(combinedData));
    }

    useEffect(() => {
        if (evaluationView && candidate?.hasKit && !isStartingWithEvaluationKit) getEvaluationKitData()
        //eslint-disable-next-line
    }, [evaluationView, candidate])

    useEffect(() => {
        if (isSuccess) {
            dispatch(setDeleteEvaluationModal(false))
            message.success(
                <>
                    <span className='text-green-800'>Evaluation is successfully Deleted. </span>
                </>, 5)
            const updatedCandidate = { ...candidate, canEvaluate: true }
            dispatch(setCandidateProfile(updatedCandidate))
        }
        else if (isError) {
            message.error(error?.status === apiStatuses.badRequest ? errorMessage : error?.data?.message || errorMessage, 5)
            dispatch(setDeleteEvaluationModal(false))
        }
        //eslint-disable-next-line
    }, [isError, error, isSuccess, dispatch])
    const handelToggleDeleteModal = () => {
        if (!isLoadingDelete) { dispatch(setDeleteEvaluationModal(!deleteModalOpen)) }
    }

    useEffect(() => {
        return () => {
            dispatch(setGenerateEvaluationKitModal(false))
            dispatch(setEvaluationView(false))
            dispatch(setShowPreview(false))
            dispatch(setDeleteEvaluationModal(false))
            dispatch(setEvaluationId(undefined))
            dispatch(setSelectedKit({}))
            dispatch(setSelectedTemplate({}))
            dispatch(setIsStartingWithEvaluationKit(false))
            dispatch(setSelectedKitTemplateData({}))
            dispatch(setIsEvaluationQuestionsModal(false))
        }
    }, [dispatch])

    useEffect(() => {
        if (isLoadingEvaluationData) {
            dispatch(setIsLoadingEvaluationData(true))
        } else if (isSuccessEvaluation) {
            dispatch(setIsLoadingEvaluationData(false))
            setKitTitle(evaluationData?.data?.evaluation?.title)
            mappingEvaluationData(evaluationData?.data?.evaluation)
        } else if (isErrorEvaluation) {
            dispatch(setIsLoadingEvaluationData(false))
            message.error(errorMessage)
        }
        //eslint-disable-next-line
    }, [isLoadingEvaluationData, isSuccessEvaluation, evaluationData, isErrorEvaluation, dispatch])

    useEffect(() => {
        if (isSuccessFeedback) {
            setFeedbacks(feedbackData?.data);
        }
        //eslint-disable-next-line
    }, [isSuccessFeedback, isFetchingFeedback])

    useEffect(() => {
        if (
            feedbacks.length > previousFeedbacksLengthRef.current && 
            commentsContainerRef.current
        ) {
            // Use multiple attempts to ensure we reach the absolute bottom
            const scrollToBottom = () => {
                if (commentsContainerRef.current) {
                    const container = commentsContainerRef.current;
                    // Scroll to the absolute bottom with extra buffer to ensure full visibility
                    container.scrollTo({
                        top: container.scrollHeight + 200,
                        behavior: 'smooth'
                    });
                }
            };

            // First attempt after DOM update
            requestAnimationFrame(() => {
                setTimeout(() => {
                    scrollToBottom();
                    // Second attempt to ensure we reach the bottom
                    setTimeout(scrollToBottom, 100);
                    // Final check to guarantee we're at the bottom
                    setTimeout(() => {
                        if (commentsContainerRef.current) {
                            const container = commentsContainerRef.current;
                            container.scrollTop = container.scrollHeight + 200;
                        }
                    }, 300);
                }, 100);
            });
        }
        previousFeedbacksLengthRef.current = feedbacks.length;
    }, [feedbacks.length])

    useEffect(() => {
        if (isSuccessDeleteComment) {
            setFeedbacks(feedbacks?.filter(feedback => feedback.feedbackId !== selectedCommentId));
            setIsOpenDeleteCommentModal(false);
            message.success('Comment deleted successfully');
        } else if (isErrorDeleteComment) {
            setIsOpenDeleteCommentModal(false);
            message.error(errorDeleteComment?.status === apiStatuses.badRequest ? errorMessage : errorDeleteComment?.data?.message || errorMessage)
        }
        //eslint-disable-next-line
    }, [isSuccessDeleteComment, isErrorDeleteComment, errorDeleteComment]);

    const onEditEvaluation = async (feedbackEvaluationId: number) => {
        dispatch(setEvaluationId(feedbackEvaluationId))
        const response = await getEvaluationById(feedbackEvaluationId)
        if (response?.data?.statusCode === apiStatuses?.success) {
            dispatch(setEvaluationView(true))
        }
    }
    const onDeleteEvaluation = (feedbackEvaluationId: number) => {
        setFeedbackEvaluationID(feedbackEvaluationId)
    }
    const handleDelete = async () => {
        await deleteEvaluation(feedbackEvaluationId)
    }

    const handleEditComment = (id: number, userId: number) => {
        if (isEditingComment || userId !== user?.id) return;
        dispatch(setIsEditingComment(true));
        dispatch(setSelectedCommentId(id));
        const selectedComment = feedbacks.find((feedback) => feedback?.feedbackId === id)?.data?.comment;
        dispatch(setInputCommentValue(selectedComment));
    }

    const handleCancelEdit = () => {
        dispatch(setIsEditingComment(false));
        dispatch(setSelectedCommentId(null));
        dispatch(setInputCommentValue(''));
    };

    const handleOpenDeleteCommentModal = (id: number, userId: number) => {
        if (isEditingComment || userId !== user?.id) return;
        dispatch(setSelectedCommentId(id));
        setIsOpenDeleteCommentModal(true)
    }

    const handleDeleteComment = async () => {
        await deleteComment({ id: selectedCommentId });
    }

    return (
        <>
            <div className='top-0 flex flex-col w-full mx-auto md:sticky md:h-screen scrollbar-hide p-7'>
                <DeleteModal
                    isVisibleModal={openWarningModal}
                    handleCloseModal={() => setOpenWarningModal(false)}
                    title="Invalid Email Address"
                    content={<p>You can't email this candidate,<br />no invalid email address available or candidate does't has email</p>}
                    footer={
                        <Button
                            className="w-full py-1 btn-default"
                            onClick={() => setOpenWarningModal(false)}
                        >
                            Ok
                        </Button>} />
                <div className='z-10 flex-shrink-0 pb-4'>
                    <div className="flex flex-wrap items-center mb-1.5">
                        {candidate?.pipelineStage?.companyStageType?.globalStageTypeId === GlobalStageTypesId.interview ?
                            <WithTooltip
                                visible={!hasJobPermission(candidate?.userRole?.roleName, getInterviewQuestions)}
                                placement='bottom'
                                title={roleError}
                            >
                                <div className='flex flex-wrap items-center grow md:flex-nowrap'>
                                    <Button loading={(isLoading || isFetching) && candidate?.hasKit} className={`px-3 mb-3 btn-secondary ${!hasJobPermission(candidate?.userRole?.roleName, getInterviewQuestions) || !candidate?.canEvaluate ? '!bg-white' : ''}`} disabled={!hasJobPermission(candidate?.userRole?.roleName, getInterviewQuestions) || !candidate?.canEvaluate} onClick={handleEvaluationQuestions}>
                                        Evaluate Candidate
                                    </Button>
                                </div>
                            </WithTooltip> : null
                        }
                        <div className='flex flex-wrap items-center justify-end grow md:flex-nowrap'>
                            <CandidatesActions withDropDown={false} candidate={candidate} key={candidate?.id} />
                            <div className="mb-3 ml-2">
                                <RejectionAction
                                    isRejectionStage={candidate?.pipelineStage?.companyStageType?.globalStageTypeId === GlobalStageTypesId.rejected}
                                    candidateId={candidate?.id}
                                    previousStageId={candidate?.previousStageId}
                                    isProfilePage={true}
                                />
                            </div>
                            {candidate?.pipelineStage?.companyStageType?.globalStageTypeId !== GlobalStageTypesId.rejected &&
                                <div className="mb-3 ml-2">
                                    <ChangeStageActions key={candidate?.id} candidateId={candidate?.id} hiringStageId={candidate?.pipelineStage?.id} isProfilePage={true} />
                                </div>
                            }
                        </div>
                    </div>
                    <div className='candidate-info'>
                        <div className="flex flex-col items-start md:flex-nowrap md:flex-row md:items-center">
                            <div className="block me-3 md:hidden"><CVScore className='w-max' cvScore={candidate?.cvScore} /></div>
                            <div className="grid items-center grid-cols-3 gap-2 md:flex md:gap-0">
                                <h3 className='inline col-span-2 font-bold text-gray-600 capitalize whitespace-nowrap md:hidden'>
                                    {candidate?.firstName && candidate?.lastName
                                        ? truncate(`${candidate?.firstName} ${candidate?.lastName}`, 20)
                                        : truncate(candidate?.cvFileName, 20) || 'File Name'}
                                </h3>
                                <h3 className='hidden font-bold text-gray-600 capitalize break-words me-4 md:block'>
                                    {candidate?.firstName && candidate?.lastName
                                        ? truncate(`${candidate?.firstName} ${candidate?.lastName}`, 40)
                                        : (candidate?.cvFileName && truncate(candidate?.cvFileName?.replace(/\.(pdf|docx)$/i, ''), 40)) || 'File Name'}
                                </h3>
                                <div className="hidden me-3 md:block"><CVScore className='w-max' cvScore={candidate?.cvScore} /></div>
                                {candidate?.isSimilar && <div className="me-3">
                                    <WithTooltip
                                        className='w-36'
                                        placement='right'
                                        colorText='#B45309'
                                        backgroundColor='#FEF3C7'
                                        width='w-48'

                                        title={<>Similarity detection: It appears that the same candidate has applied for multiple positions.
                                            <h4 className='mt-3 cursor-pointer' onClick={handleTooltipClick}>Click to compare.</h4></>}
                                    >
                                        <img onClick={handleTooltipClick} src={ExclamationYellow} alt='Similarity detection' className='inline cursor-pointer' />
                                    </WithTooltip>
                                </div>}
                            </div>
                        </div>
                        {departmentName && (
                            <div className='flex mb-4'>
                                <img className="mr-1" src={officeIcon} alt='department' />
                                <div className="text-sm font-normal text-gray-600 break-words">
                                    {parentDepartment ? `${parentDepartment} / ` : ''}{departmentName}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div ref={commentsContainerRef} className='flex-1 min-h-0 pb-8 overflow-y-auto'>
                    <p className='text-gray-600 mb-1.5 break-words'>{(viewMore && candidate?.longSummary ? `${candidate?.longSummary?.slice(0, 120)}...` : candidate?.longSummary) ?? 'Score and Summary for this candidate are being processed...'}</p>
                    {candidate?.longSummary &&
                        <Button className='p-0 btn-link' onClick={() => { setViewMore(!viewMore) }}>View {`${viewMore ? 'More' : 'Less'}`}</Button>}
                    <Divider dashed className='my-4 border-neutral-500' />
                    {(candidate?.strengths?.length > 0 || candidate?.weaknesses?.length > 0) &&
                        <>
                            <div className='grid gap-3 md:grid-cols-2'>
                                {candidate?.strengths?.length > 0 && <FeaturesList title="Strength" list={candidate?.strengths} />}
                                {candidate?.weaknesses?.length > 0 && <FeaturesList title="Weakness" list={candidate?.weaknesses} />}
                            </div>
                            <Divider dashed className='my-4 border-neutral-500' />
                        </>
                    }
                    <Attributes applicationCriteriasEvaluation={candidate?.applicationCriteriasEvaluation} />
                    <Divider dashed className='my-4 border-neutral-500' />
                    {/* <div className='pb-2 text-indigo-700'>
                        <span className="inline">Comments {`(${commentsData?.comments?.length ?? '0'})`}</span>
                        <img src={getImageUrl('commentIcon')} alt="Comments" className="inline ml-2" />
                    </div> */}
                    {
                        candidate?.formAnswers && <>
                            <CandidateInfo applicationAnswers={candidate?.formAnswers} />
                            <Divider dashed className='my-4 border-neutral-500' />
                        </>
                    }
                    <div>
                        <h3 className='py-3 text-sm font-semibold text-gray-600'>Activities</h3>
                    </div>
                    <div className="flex flex-col-reverse pt-3 min-h-52">
                        {isLoadingFeedback ?
                            <div className='w-full mb-auto'>
                                <LazyLoader />
                                <p className='mt-4 text-base font-normal text-indigo-600'>Retrieving comments..</p>
                            </div>
                            : (isSuccessFeedback && feedbackData?.data?.length > 0) ?
                                feedbacks?.map((feedback: IGetFeedback, key: number) => {
                                    if (feedback?.feedbackId === selectedCommentId && isEditingComment) return null;
                                    return <>
                                        {feedback?.feedbackTypeId === FeedbackTypeId?.comment ?
                                            <Comment key={feedback?.feedbackId} name={feedback?.name} postedAt={feedback?.createdAt} text={formatCommentMentions(feedback?.data?.comment as string, mentionables)} id={feedback?.feedbackId} onEdit={handleEditComment} onDelete={handleOpenDeleteCommentModal} updatedAt={feedback?.updatedAt} userId={feedback?.userId} />
                                            : feedback?.feedbackTypeId === FeedbackTypeId?.aiEvaluationSummary ?
                                                <AiEvaluationSummary key={feedback?.feedbackId} feedback={feedback} text={formatCommentMentions(feedback?.data?.summary as string, mentionables)} />
                                                : <FeedbackEvaluation key={key} feedback={feedback} onShowPreview={(evaluationId: number) => getEvaluationPreview(evaluationId)} onDelete={(evaluationId: number) => onDeleteEvaluation(evaluationId)} onEdit={(evaluationId: number) => onEditEvaluation(evaluationId)} />
                                        }
                                    </>
                                })
                                : isErrorFeedback ?
                                    <div className="flex items-center justify-center flex-grow h-full">
                                        <EmptyList title="Something went wrong" description='Failed loading comments, please refresh' />
                                    </div>
                                    :
                                    <div className="flex items-center justify-center flex-grow h-full">
                                        <EmptyList title="" description='All activities, evaluation and comments will appear here' className='flex flex-col items-center justify-center [&_.ant-empty-image_img]:w-[6.238125rem] [&_.ant-empty-image_img]:h-[5.25rem] [&_.ant-empty-image]:mb-0 [&_.ant-empty-description_p]:text-sm [&_.ant-empty-description_p]:leading-8' />
                                    </div>
                        }
                    </div>
                </div>
                {/* Fixed Footer Section */}
                <div className='sticky bottom-0 flex-shrink-0 pb-4 bg-[#F6F6F9] rounded-t-lg pt-2 z-50'>
                    <div
                        className='absolute inset-x-0 top-0 h-2 -translate-y-full pointer-events-none'
                        style={{ background: 'linear-gradient(to top, #F6F6F9, transparent)' }}
                    />
                    <Divider dashed className='my-4 border-neutral-500' />
                    <AddComment users={mentionables} handleCancelEdit={handleCancelEdit} />
                </div>
            </div>
            <DeleteModal
                isVisibleModal={deleteModalOpen}
                handleCloseModal={handelToggleDeleteModal}
                title="Delete Evaluation"
                content={<p>Are you sure you want to delete this Evaluation?<br />This action is permanent and cannot be undone.</p>}
                footer={
                    <div className='grid gap-3 md:grid-cols-2'>
                        <Button
                            loading={isLoadingDelete}
                            className=' btn-md btn-danger'
                            onClick={() => handleDelete()}>
                            Delete
                        </Button>
                        <Button
                            disabled={isLoadingDelete}
                            className='btn-md'
                            htmlType='submit'
                            onClick={handelToggleDeleteModal}>
                            Cancel
                        </Button>
                    </div>}
            />
            <DeleteModal
                isVisibleModal={isOpenDeleteCommentModal}
                handleCloseModal={() => setIsOpenDeleteCommentModal(false)}
                title="Delete comment?"
                content={<p>Are you sure you want to delete this comment?<br />This action can’t be undone.</p>}
                footer={
                    <div className='grid gap-3 md:grid-cols-2'>
                        <Button
                            loading={isLoadingDeleteComment}
                            className=' btn-md btn-danger'
                            onClick={handleDeleteComment}>
                            Delete
                        </Button>
                        <Button
                            disabled={isLoadingDeleteComment}
                            className='btn-md'
                            htmlType='submit'
                            onClick={() => setIsOpenDeleteCommentModal(false)}>
                            Keep It
                        </Button>
                    </div>}
            />
            <ModalComponent visibleModal={evaluationView}
                handleCloseModal={() => {
                    dispatch(setEvaluationView(false))
                    dispatch(setIsSuccessSavingEvaluationKitTosStage(false))
                    if (evaluationId) mappingEvaluationData(evaluationData?.data?.evaluation)
                    dispatch(setEvaluationId(undefined))
                }}
                width={1010}
                content={
                    <ModalBody
                        title={
                            <div className=''>
                                {kitTitle && kitTitle}
                            </div>}
                        className="text-start"
                    >
                        <div id="pdf-content">
                            {isLoading && candidate?.hasKit ? <div className="w-full h-[34.5rem] flex flex-col justify-center items-center">
                                <LazyLoader />
                                <h3 className="mt-2 text-indigo-700">Retrieving Evaluation Questions..</h3>
                            </div>
                                : <EvaluationForm kitTitle={kitTitle} />
                            }
                        </div>
                    </ModalBody>
                }
            />
            <GenerateKitModal />
            <PreviewQuestions kitTemplateData={evaluationSections} kitTemplateTitle={kitTitle} />
            <EvaluationQuestionsModal />
            <InterviewKitNameModal fromProfile={true} kitTitle={kitTitle} />
        </>
    );
};

export default Comments;
